"use client";
import { createTheme } from "@mui/material/styles";

import { MuiChip } from "./badge";
import { MuiButton, MuiIconButton } from "./buttons";
import { palette } from "./palette";
import { typography } from "./typography";

const theme = createTheme({
  cssVariables: true,
  typography,
  palette: palette,
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 768,
      lg: 1024,
      xl: 1440,
    },
  },
  shape: {
    borderRadius: 4,
  },
  components: {
    MuiChip,
    MuiButton,
    MuiIconButton,
    MuiButtonBase: {
      defaultProps: {
        disableTouchRipple: true,
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "var(--mui-palette-neutral1-medium, #afafaf)",
          },
          "&:hover:not(.Mui-error) .MuiOutlinedInput-notchedOutline": {
            borderColor: "var(--mui-palette-text-primary, #afafaf)",
          },
          "&.Mui-focused:not(.Mui-error) .MuiOutlinedInput-notchedOutline": {
            borderColor: "var(--mui-palette-text-primary, #656565)",
            borderWidth: "2px",
          },
        },
      },
    },
    MuiTypography: {
      defaultProps: {
        variantMapping: {
          headingXXL: "h1",
          headingXL: "h2",
          headingL: "h3",
          headingM: "h4",
          headingS: "h5",
          headingXS: "h6",
        },
      },
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          backgroundColor: "transparent",
          margin: 0,
          border: "none",
          boxShadow: "none",
          "&::before": {
            display: "none",
          },
        },
      },
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          padding: 0,
          minHeight: "50px",
          "& .MuiAccordionSummary-content": {
            margin: 0,
          },
          "&.Mui-expanded": {
            minHeight: "50px",
            margin: 0,
          },
          "&.Mui-expanded .MuiAccordionSummary-content": {
            margin: 0,
          },
        },
      },
    },
    MuiAccordionDetails: {
      styleOverrides: {
        root: {
          paddingBottom: 0,
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        b: {
          fontWeight: 600,
        },
        strong: {
          fontWeight: 600,
        },
        a: {
          color: "inherit",
        },
      },
    },
  },
});

export default theme;
